import angular from 'angular';
import contractDropdownComponent from './contract-dropdown.component';

let contractDropdownModule = angular.module('contractDropdown', [])
  .component('contractDropdown', contractDropdownComponent);

export default contractDropdownModule;




// WEBPACK FOOTER //
// ./client/common/directives/contract-dropdown/contract-dropdown.js